import { type FormEvent, useState } from 'react';
import { useTranslation } from 'react-i18next';
import type { PatientInput } from './api';

type Props = { busy: boolean; onSubmit: (input: PatientInput) => void };

export function PatientForm({ busy, onSubmit }: Props) {
  const { t } = useTranslation();
  const [lastName, setLastName] = useState('');
  const [firstName, setFirstName] = useState('');
  const [birthDate, setBirthDate] = useState('');
  const [phone, setPhone] = useState('');
  const [notes, setNotes] = useState('');

  const submit = (e: FormEvent) => {
    e.preventDefault();
    onSubmit({
      lastName: lastName.trim(),
      firstName: firstName.trim(),
      birthDate: birthDate || null,
      phone: phone.trim() || null,
      notes: notes.trim() || null,
    });
  };

  return (
    <form className="stack" onSubmit={submit}>
      <div className="field">
        <label htmlFor="p-last">{t('patients.form.lastName')}</label>
        <input
          id="p-last"
          className="input"
          required
          data-autofocus
          autoComplete="off"
          value={lastName}
          onChange={(e) => setLastName(e.target.value)}
        />
      </div>
      <div className="field">
        <label htmlFor="p-first">{t('patients.form.firstName')}</label>
        <input
          id="p-first"
          className="input"
          required
          autoComplete="off"
          value={firstName}
          onChange={(e) => setFirstName(e.target.value)}
        />
      </div>
      <div className="field">
        <label htmlFor="p-birth">{t('patients.form.birthDate')}</label>
        <input
          id="p-birth"
          className="input"
          type="date"
          value={birthDate}
          onChange={(e) => setBirthDate(e.target.value)}
        />
      </div>
      <div className="field">
        <label htmlFor="p-phone">{t('patients.form.phone')}</label>
        <input
          id="p-phone"
          className="input"
          type="tel"
          inputMode="tel"
          value={phone}
          onChange={(e) => setPhone(e.target.value)}
        />
      </div>
      <div className="field">
        <label htmlFor="p-notes">{t('patients.form.notes')}</label>
        <textarea
          id="p-notes"
          className="textarea"
          maxLength={1000}
          value={notes}
          onChange={(e) => setNotes(e.target.value)}
        />
      </div>
      <button type="submit" className="btn btn--primary btn--block" disabled={busy}>
        {t('patients.form.submit')}
      </button>
    </form>
  );
}
